import { INotesDetails } from '@modeso/aumico-lib-annualreport-fe';

export interface ITableOfContentEntry {
    id: string;
    labelOrLabelKey: string;
    pageNumberPlaceHolder: string;
    isLocalized: boolean;
    subItems?: INotesDetails[];
}
